import { Meeting } from "features/Resources/Meeting/models";
import { MenuItem } from "@chakra-ui/react";
import SkipMeetingButton from "../../Button/SkipMeetingButton";
import { VThreeDotMenu } from "components/Menu/ThreeDotMenu";
import { Text14 } from "components/Text";
import { SchedulingMenuButton } from "../../Button/Scheduling";

export function OtherActionsColumn({ meeting }: { meeting: Meeting }) {
  if (!meeting || !meeting.id) {
    return null;
  }
  return (
    <VThreeDotMenu inPortal={true}>
      {meeting.status !== "pending_scheduling" && (
        <SchedulingMenuButton meeting={meeting} />
      )}
      {meeting.status !== "completed" && (
        <SkipMeetingButton meeting={meeting}>
          {(title) => (
            <MenuItem>
              <Text14>{title}</Text14>
            </MenuItem>
          )}
        </SkipMeetingButton>
      )}
    </ VThreeDotMenu>
  )
}
